const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "64px",
    height: "64px",
    fill: "currentColor",
    viewBox: "0 0 64 64",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.985
    },
    fill: "#020202",
    d: "M 10.5,3.5 C 24.8372,3.33342 39.1705,3.50009 53.5,4C 56,5.16667 57.8333,7 59,9.5C 59.6667,24.1667 59.6667,38.8333 59,53.5C 58.2155,55.286 57.0488,56.786 55.5,58C 40.2594,59.6342 24.9261,59.9675 9.5,59C 7,57.8333 5.16667,56 4,53.5C 3.33333,39.1667 3.33333,24.8333 4,10.5C 5.69406,7.64238 7.86073,5.30904 10.5,3.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2f2f2",
    d: "M 29.5,27.5 C 29.5,29.1667 29.5,30.8333 29.5,32.5C 28.209,32.2627 27.209,32.596 26.5,33.5C 22.9874,35.9083 22.6541,38.7417 25.5,42C 28.8342,43.2121 31.3342,42.3788 33,39.5C 33.4997,31.1733 33.6664,22.84 33.5,14.5C 35.1667,14.5 36.8333,14.5 38.5,14.5C 39.1903,18.6883 41.6903,21.0216 46,21.5C 46.4966,23.8098 46.6633,26.1432 46.5,28.5C 44.1727,28.7529 42.1727,28.0863 40.5,26.5C 39.9093,32.2455 39.0759,37.9121 38,43.5C 32.0578,50.9536 25.7244,51.287 19,44.5C 16.4179,38.7129 17.2512,33.5463 21.5,29C 24.0135,27.7475 26.6802,27.2475 29.5,27.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#727272",
    d: "M 29.5,27.5 C 30.4614,29.2646 30.7947,31.2646 30.5,33.5C 29.1667,33.5 27.8333,33.5 26.5,33.5C 27.209,32.596 28.209,32.2627 29.5,32.5C 29.5,30.8333 29.5,29.1667 29.5,27.5 Z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.b77ab7afed978328aff76a38f11f20c3.svg";
export { ForwardRef as ReactComponent };